import React from "react";
import "./language.css";

const Lanuage = () => {
  return (
    <>
    <div className="language-container">
      <div class="navbar">
        <a href="#html">HTML</a>
        <a href="#css">CSS</a>
        <a href="#js">JAVASCRIPT</a>
        <a href="#sql">SQL</a>
        <a href="#python">PYTHON</a>
        <a href="#java">JAVA</a>
        <a href="#php">PHP</a>
        <a href="#how to">HOWTO</a>
        <a href="#w3css">W3.CSS</a>
        <a href="#c">C</a>
        <a href="#c++">C++</a>
        <a href="bootstrap">BOOTSTRAP</a>
        <a href="#react">REACT</a>
        <a href="mysql">MYSQL</a>
         <a href="query">JQUERY</a>
      </div>
      </div>
    </>
  );
};

export default Lanuage;

